<template>
  <span>{{ item[header.value].length }}</span>
</template>

<script>
export default {
  name: 'LengthContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
